import { 
    ShoppingCartIcon,
    WrenchScrewdriverIcon,
    ClockIcon,
    CogIcon,
    ArrowUpTrayIcon,
    CubeIcon,
    ArrowPathIcon,
    TruckIcon,
    ArrowsRightLeftIcon,
    CalendarIcon,
    ClipboardDocumentCheckIcon,
    GlobeAltIcon,
    SignalIcon
  } from '@heroicons/react/24/outline';
  
  const servicesData = [
    {
      id: 1,
      title: "Sales Navigation, Communication, Safety and Other Marine Equipments",
      shortDescription: "Complete range of marine equipment sales for all your maritime needs.",
      longDescription: "We offer a comprehensive range of marine equipment sales, including navigation systems, communication devices, and safety equipment. Our products are sourced from leading manufacturers to ensure quality and reliability.",
      features: [
        "Navigation systems from leading brands",
        "State-of-the-art communication equipment",
        "Complete safety gear and systems",
        "Quality certified products",
        "Competitive pricing",
        "Product warranty support"
      ],
      icon: ShoppingCartIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 2,
      title: "Installation and Commissioning of Equipments",
      shortDescription: "Expert installation services by certified technicians.",
      longDescription: "Our team of expert technicians provides professional installation and commissioning services for all types of marine equipment. We ensure that your equipment is installed correctly and operates efficiently.",
      features: [
        "Professional installation team",
        "Certified technicians",
        "Quality assurance testing",
        "Performance verification",
        "Documentation and training",
        "Compliance with regulations"
      ],
      icon: WrenchScrewdriverIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 3,
      title: "Sales After Service",
      shortDescription: "Reliable after-sales support for your equipment.",
      longDescription: "We provide comprehensive after-sales support to ensure the continuous operation of your marine equipment. Our services include regular maintenance, troubleshooting, and repairs to keep your equipment in top condition.",
      features: [
        "24/7 technical support",
        "Regular maintenance checks",
        "Quick response time",
        "Remote assistance",
        "Warranty management",
        "Performance monitoring"
      ],
      icon: ClockIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 4,
      title: "Repairs, Troubleshooting and Replacement of Faulty Parts",
      shortDescription: "Swift repair and maintenance solutions for all equipment.",
      longDescription: "Our expert technicians offer repair services and troubleshooting for all types of marine equipment. We also provide replacement of faulty parts to ensure your equipment operates smoothly.",
      features: [
        "Expert diagnostic services",
        "Genuine replacement parts",
        "Quick turnaround time",
        "Emergency repair service",
        "Preventive maintenance",
        "Performance optimization"
      ],
      icon: CogIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 5,
      title: "Software & Hardware Upgrade of Equipments",
      shortDescription: "Latest upgrades to enhance equipment performance.",
      longDescription: "We offer the latest software and hardware upgrades to keep your marine equipment up-to-date. Our upgrades ensure that your equipment operates with the latest features and improvements.",
      features: [
        "Latest software versions",
        "Hardware compatibility checks",
        "System optimization",
        "Performance enhancement",
        "Security updates",
        "Upgrade consultation"
      ],
      icon: ArrowUpTrayIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 6,
      title: "Supply Spare Parts of All Brands",
      shortDescription: "Genuine spare parts for all major brands.",
      longDescription: "We supply genuine spare parts for all major marine equipment brands. Our spare parts are sourced from trusted manufacturers to ensure quality and compatibility with your equipment.",
      features: [
        "Original manufacturer parts",
        "Wide brand coverage",
        "Quality assurance",
        "Competitive pricing",
        "Fast sourcing",
        "Inventory management"
      ],
      icon: CubeIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 7,
      title: "Supply Recondition and/or Secondhand Equipments",
      shortDescription: "Quality reconditioned equipment solutions.",
      longDescription: "We offer quality reconditioned and secondhand equipment options for cost-effective solutions. Our reconditioned equipment is thoroughly tested and certified to ensure reliable performance.",
      features: [
        "Quality testing",
        "Performance certification",
        "Cost-effective options",
        "Warranty coverage",
        "Installation support",
        "Technical documentation"
      ],
      icon: ArrowPathIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 8,
      title: "Delivery of Spare Parts",
      shortDescription: "Global spare parts delivery service.",
      longDescription: "Our fast and reliable delivery service ensures that spare parts are delivered to you promptly, no matter where you are in the world. We prioritize timely delivery to minimize downtime for your equipment.",
      features: [
        "Worldwide shipping",
        "Express delivery options",
        "Package tracking",
        "Custom clearance support",
        "Secure packaging",
        "Delivery insurance"
      ],
      icon: TruckIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 9,
      title: "Exchange of Modules",
      shortDescription: "Efficient module exchange program.",
      longDescription: "Our module exchange service provides a quick and efficient solution for equipment maintenance. We offer a range of modules for exchange to ensure your equipment is back in operation as soon as possible.",
      features: [
        "Quick replacement",
        "Quality tested modules",
        "Wide range availability",
        "Technical support",
        "Installation guidance",
        "Warranty coverage"
      ],
      icon: ArrowsRightLeftIcon,
      image: require("../Assets/images/services1.jpg")
    },
    // {
    //   id: 10,
    //   title: "Annual Maintenance of Gyrocompass",
    //   shortDescription: "Specialized gyrocompass maintenance service.",
    //   longDescription: "Our annual maintenance service for gyrocompass systems ensures optimal performance and reliability. We conduct thorough inspections and maintenance to keep your gyrocompass in top condition.",
    //   features: [
    //     "Comprehensive inspection",
    //     "Performance testing",
    //     "Calibration service",
    //     "Preventive maintenance",
    //     "Documentation",
    //     "Certification"
    //   ],
    //   icon: CalendarIcon,
    //   image: require("../Assets/images/services1.jpg")
    // },
    {
      id: 11,
      title: "Vdr / Svdr annual performance test",
      shortDescription: "Comprehensive VDR/SVDR performance testing and certification services.",
      longDescription: "We are approved by many manufacturers to carry out Annual Performance Testing of S/VDR and provide all required testing with fault detection by well trained engineers sertified from major brands.",
      features: [
      "Annual performance testing",
    "Manufacturer approved procedures",
    "Detailed fault detection",
    "Certified engineering team",
    "Test documentation",
    "International standards compliance"
      ],
      icon: ClipboardDocumentCheckIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 12,
      title: "Gyro Overhaul Service",
      shortDescription: "Professional gyroscope maintenance and overhaul services.",
      longDescription: "We have experience in servicing a wide range of equipment covering most major manufacturers . Our maintenance services include repairs, troubleshooting and replacement of defective parts.",
      features: [
        "Comprehensive inspection",
    "Performance testing",
    "Calibration service",
    "Preventive maintenance",
    "Documentation",
    "Certification",
    "Full system check",
    "Precision calibration"
      ],
      icon: GlobeAltIcon,
      image: require("../Assets/images/services1.jpg")
    },
    {
      id: 13,
      title: "GMDSS Survey Service",
      shortDescription: "Comprehensive GMDSS inspection and programming services.",
      longDescription: "When require change of flag management or ownership,GMDSS equipment are required to be reprogrammed with new vessel name, MMSI No. etc. We carry out reprogramming of a wide range of GMDSS equipment such as EPIRB, AIS, MF/HF, SSAS etc. with the new details thus providing the owners with a complete peace of mind. Surveyors have been certificated from all IACS member as approved radio Surveyor.",
      features: [
       "EPIRB programming",
    "AIS system updates",
    "MF/HF radio programming",
    "SSAS system configuration",
    "IACS certified surveyors",
    "Flag change support",
    "Complete documentation"
      ],
      icon: SignalIcon,
      image: require("../Assets/images/services1.jpg")
    },
  ];
  
  export default servicesData;